import { useState } from 'react';
import { ConfirmDialog } from './ConfirmDialog';

interface SignOutButtonProps {
  onSignOut: () => void;
  /** Hay un partido en curso: el aviso dice que también se sale de él. */
  inMatch?: boolean;
  className?: string;
  label?: string;
}

/**
 * Botón de cerrar sesión con confirmación. Cancelar no hace nada; confirmar llama a `onSignOut`
 * tal cual (el cierre y su limpieza no cambian).
 */
export const SignOutButton = ({ onSignOut, inMatch = false, className = 'btn-ghost h-9 px-3 text-xs', label = 'Salir' }: SignOutButtonProps) => {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} aria-haspopup="dialog" className={className}>
        {label}
      </button>
      <ConfirmDialog
        open={open}
        title="¿Cerrar sesión?"
        message={
          inMatch
            ? 'Hay un partido en curso. Si cierras sesión, saldrás del partido.'
            : 'Tendrás que volver a iniciar sesión para jugar con tu cuenta.'
        }
        confirmLabel="Cerrar sesión"
        danger
        onCancel={() => setOpen(false)}
        onConfirm={() => {
          setOpen(false);
          onSignOut();
        }}
      />
    </>
  );
};
